import React, { Component } from 'react';
import Sound from '../UI/Sound';
import {isEmpty} from '@lsgo/lsgo-common/utils';
import { pickRandom } from '@lsgo/lsgo-common';

import happy_dragon from '../../assets/images/student/happy_dragon.gif';
import happy_sun from '../../assets/images/student/happy_sun.gif';
import happy_fish from '../../assets/images/student/happy_fish.gif';

import withActivityAnalytics from '../../hoc/WithActivityAnalytics';
import { TYPES } from '../../constants/activityTypes';

class QuizMultiAnswer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentAnswer: [],
            celebrationImage: null,
            showResults: false,
            skip: false,
            selected: null,
            tries: 0,
            isSubmitting: false,
            submitClicked: false,
        };

        const { demoMode } = this.props;

        this.handleAnswerClick = this.handleAnswerClick.bind(this);
    }

    handleAnswerClick(choice) {
        const { currentAnswer } = { ...this.state };

        const location = currentAnswer.indexOf(choice.id);
        if (location !== -1) {
            currentAnswer.splice(location, 1);
        } else {
            currentAnswer.push(choice.id);
        }

        this.setState({
            currentAnswer,
            tries: this.state.tries + 1,
        });
    }

    handleSubmit = () => {
        const { currentAnswer, tries, submitClicked } = this.state;
        const { correct, choices, startTime, activityId } = this.props;
        let timeout = 5000;
        let score = 0;

        //check if the student tried at least once
        if (tries === 0) {
            this.props.dispatchAddAlert('Have a try');

            if (!submitClicked) {
                this.setState({
                    submitClicked: true,
                });
            }

            return false;
        }

        //01. show results
        this.setState({
            showResults: true,
            isSubmitting: true,
        });

        //02.check if all the answers are correct
        const correctAnswers = currentAnswer.filter((answerId) => correct.indexOf(answerId) !== -1);

        //get all unselected answers
        let unselectedAnswer = choices.filter((choice) => {
            return currentAnswer.indexOf(choice.id) === -1;
        });

        //filter incorrect answers among unselected answers
        unselectedAnswer = unselectedAnswer.filter((answer) => correct.indexOf(answer.id) === -1);

        //add correct answers and incorrect unselected answers.
        score = correctAnswers.length + unselectedAnswer.length;

        const isCorrect = score === choices.length;

        if (isCorrect) {
            this.setState({
                celebrationImage: pickRandom([happy_sun, happy_fish, happy_dragon]),
            });
            timeout = 3000;
            this.props.dispatchAddToScore('brain', correctAnswers.length);
        }

        const endTime = this.props.endTime();

        const resultObj = {
            questions: choices.length,
            correct: isCorrect * 1, //save boolean to 0 or 1
            correctAnswers: score,
            answer: this.state.currentAnswer,
        };

        this.props.pushActivityAnalytics(startTime, endTime, TYPES.QUIZ_MULTI_MULTI.ID, activityId, resultObj);

        setTimeout(() => {
            this.props.activityDone();
            this.setState({
                isSubmitting: false,
            });
        }, timeout);
    };

    renderChoices() {
        const { choices, correct } = this.props;

        const { showResults, currentAnswer } = this.state;

        return choices.map((choice, i) => {
            const style = {};

            if (choice.image) {
                Object.assign(style, {
                    backgroundImage: `url(${choice.image})`,
                });
            }

            if (choice.color) {
                Object.assign(style, {
                    backgroundColor: choice.color,
                });
            }

            const choiceClass = [];

            if (currentAnswer.indexOf(choice.id) !== -1) {
                choiceClass.push('shadow-dr');
            }

            if (showResults && correct.indexOf(choice.id) !== -1) {
                choiceClass.push('answer-correct');
            }

            if (showResults && correct.indexOf(choice.id) === -1) {
                choiceClass.push('answer-in-correct');
            }

            return (
                <div
                    key={choice.id}
                    className={`answer-container ${choiceClass.join(' ')}`}
                    style={style}
                    onClick={this.handleAnswerClick.bind(this, choice)}
                >
                    <div className='answer-inner-indicate'>
                        <i className='material-icons' style={{ color: '#7b7', fontSize: 42 }}>
                            {'check'}
                        </i>
                    </div>
                    <div className='quiz-answer'>{!choice.image && choice.title && choice.title}</div>
                    {'sound' in choice && !isEmpty(choice.sound) && <Sound audioUrl={choice.sound} />}
                </div>
            );
        });
    }

    render() {
        const { question, questionImage, questionSound, demoMode } = this.props;
        const { celebrationImage, submitClicked, isSubmitting } = this.state;

        const choices = this.renderChoices();

        return (
            <div className='quiz-wrapper'>
                <div className='quiz-content'>
                    <div className='quiz-question'>
                        <h3>{question}</h3>
                        {questionSound && <Sound audioUrl={questionSound} />}
                        {questionImage && (
                            <div className='quiz-question-img'>
                                <img alt={question} src={questionImage} />
                            </div>
                        )}
                    </div>
                    <div className='quiz-answers'>{choices}</div>
                    <div className='clearfix'></div>
                </div>

                {!demoMode && (
                    <div
                        style={{
                            marginBottom: 10,
                            marginTop: 15,
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {isSubmitting && (
                            <div className='lds-ellipsis'>
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        )}
                        <button
                            onClick={this.handleSubmit.bind(this)}
                            className='student-submit-btn'
                            disabled={isSubmitting || (submitClicked && !this.state.currentAnswer.length)}
                        >
                            SUBMIT
                        </button>
                    </div>
                )}
                {celebrationImage && (
                    <div className='celebrationImage'>
                        <img alt='' style={{ marginTop: 100 }} width={300} height={300} src={celebrationImage} />
                    </div>
                )}
            </div>
        );
    }
}

export default withActivityAnalytics(QuizMultiAnswer);
